export default "/images/vendor/flag-icons/flags/4x3/to.svg?a7375d4d2ef32a2c8761849cac54fa64";